import React from 'react';

function Twitter(props: object) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.625 0.625H7.1875L11.8553 7.13816L17.5 0.625H20L12.9869 8.7171L20.625 19.375H14.0625L9.39474 12.8619L3.75 19.375H1.25L8.26316 11.2829L0.625 0.625ZM15.0255 17.5L4.27554 2.5H6.22446L16.9745 17.5H15.0255Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Twitter;
